import React, { memo } from "react";
import { MessageSquareShare } from "lucide-react";
import IconButton from "../ui/Button/IconButton";

const ShareButton = memo(() => {
  const handleShareClick = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Share Persona",
          url: window.location.href,
        })
        .catch((error) => console.error("Error sharing", error));
    } else {
      navigator.clipboard
        .writeText(window.location.href)
        .then(() => alert("Link copied to clipboard!"))
        .catch((error) => console.error("Error copying link", error));
    }
  };

  return (
    <IconButton
      icon={<MessageSquareShare className="text-green-500 w-5 h-5" />}
      variant="ghost"
      size="icon"
      onClick={handleShareClick}
      tooltip="Share"
      tooltipPosition="top"
      tooltipTheme="green-tooltip"
      className=" !bg-grey-500 !shadow-lg hover:shadow-2xl hover:shadow-green-200/50"
    />
  );
});

ShareButton.displayName = "ShareButton";

export default ShareButton;
